import apiClient from "../core/HttpClient";
import GreetingMembership from "../models/GreetingMembership";

export default class GreetingMembershipService {
  url = "/GreetingMemberships";

  public async getGreetingMemberships(): Promise<GreetingMembership[]> {
    return await apiClient.get(this.url).then((res) => res.data);
  }

  public async getGreetingMembershipById(id: string): Promise<GreetingMembership> {
    return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
  }

  public async createGreetingMembership(model: GreetingMembership) {
    return await apiClient.post(this.url, model);
  }

  public async updateGreetingMembership(model: GreetingMembership) {
    return await apiClient.put(`${this.url}/${model.id}`, model);
  }

  public async deleteGreetingMembership(id: string) {
    return await apiClient.delete(`${this.url}/${id}`);
  }
}
